import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
class CreateImageLine extends Component {
  state = {};
  render() {
    return (
      <div className="row max_width_500 pt-2 width_100">
        {/* <div className="width_image_question "> */}

        {/* </div> */}
        <div className="width_text_question" style={{ position: "relative" }}>
          <FontAwesomeIcon
            icon={faTimes}
            className="btn_img_delete yaystack_color"
            onClick={this.props.handleRemoveImage}
          />
          <img src={this.props.image} alt="upload" />
        </div>
        {/* <div className="width_image_question" /> */}
      </div>
    );
  }
}

export default CreateImageLine;



// WEBPACK FOOTER //
// ./src/components/create_question/create_image_line.jsx